import { render, staticRenderFns } from "./FilmCard.vue?vue&type=template&id=9015c04a&"
import script from "./FilmCard.vue?vue&type=script&lang=js&"
export * from "./FilmCard.vue?vue&type=script&lang=js&"
import style0 from "./FilmCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports